const FlagMappings = require('./FlagMappings.json');
const findKey = require('lodash.findkey');

const mapFlag = (flag, params, map = null) => {
  const Mappings = map || FlagMappings;
  // flag is the text value you want to map away from
  const options = {
    category: params.category || null,
    from: params.from || null,
    status: params.status || null,
    to: params.to || null,
    type: params.type || null,
  };

  /*
   * For logic purposes:
   * A: enum
   * B: long
   * C: short
   *
   * Because findKey will return the first index matching the
   * second parameter, we can't ever map from B because B is a
   * not a unique property value (many other flags have the same
   * long values), so without more specificity in the second
   * param, we can't locate the correct matching key.
   *
   * findKey accepts an object and an match to start from
   */

  // "other" mappings (need invoice status to know where to map)
  if (flag === 'other' && options.to === 'enum') {
    return `${options.status} other`;
  }

  // Find the key
  // Find the key
  // Find the key

  let key;
  let returnValue;

  // A -> B/C
  if (options.from === 'enum') {
    // If flag doesn't exist as a key on Mappings, return flag
    if (Mappings?.[flag]) {
      key = flag;
    }
  }
  // C -> A
  // C -> B (vice versa)
  else {
    key = findKey(
      Mappings,
      (i) => {
        return i[options.from]?.toLowerCase() === flag.trim().toLowerCase()
          && i.status?.includes(options.status)
      }
    )
  }


  // Evaluate the return value
  // Evaluate the return value
  // Evaluate the return value

  if (key) {
    if (options.to === 'enum') {
      returnValue = key;
    }
    // If to is null, return enum (not all flags have a long/short)
    else if (Mappings[key][options.to] === null) {
      returnValue = key;
    }
    else {
      returnValue = Mappings[key][options.to];
    }
  }
  // Return the passed in flag if there wasn't a key (there isn't
  // mappings needed for every flag)
  else {
    returnValue = flag;
  }

  return returnValue;
};

const mapFlags = (flags, params, map = null) => {
  const options = {
    from: params.from || null,
    to: params.to || null,
    status: params.status || null,
  };
  let returnValue = [];

  flags.forEach((flag) => {
    returnValue.push(mapFlag(flag, options, map))
  })
  return [ ...new Set(returnValue) ];
};

module.exports = {
  mapFlag,
  mapFlags
};
